export interface SubmittedCatalogJob {
  serviceName: string;
  jobId?: string;
}

export interface CatalogJobLocationState {
  submittedCatalogJob?: SubmittedCatalogJob;
}

export function catalogJobHref(serviceName?: string): string {
  return `/jobs/${encodeURIComponent(serviceName || '')}`;
}
